module.exports = __webpack_public_path__ + "img/Heron.5fe356a6.jpg";